import React from "react";
import { styled } from "@mui/styles";

const StyledOnBoardingSlide = styled('div')(({theme}) => ({
        padding: "1.5rem 5rem 1.25rem",

        '& p': {
            userSelect: 'none',
        },

        '& img': {
            height: '9rem',
            display: 'block',
            margin: '0.9rem auto',
            objectFit: 'contain',
            verticalAlign: 'middle',
            maxWidth: '100%',
        }
    }
));

const OnBoardingSlide = ({ children }) => {
    return (
        <StyledOnBoardingSlide>
            { children }
        </StyledOnBoardingSlide>
    )
}

export default OnBoardingSlide;
